export { ContentController as Content } from './content-controller';
